import React, { useState, useEffect } from 'react';
import { TfiMedall } from 'react-icons/tfi';
import { Link } from 'react-router-dom';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import CourseCover from '@/assets/images/placeholders/show-course.jpg';
import useAuthorityLevel from '@/hooks/useAuthorityLevel';
import TabNavBar from './TabNavBar';
import TabFiles from './TabFiles';
import TabActivities from './TabActivities';
import TabBooklet from './TabBooklet';
import { useSession } from '@/hooks/useSession';
import { Loader } from '@/components/custom/loader';
import { t } from 'i18next';
import TabLessons from './TabLessons';
import { MedalContainer } from '@/components/custom/medal';

export default function ViewModule(props) {
  const { moduleId } = props;

  const [currentModule, setCurrentModule] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState('aulas');

  const client = useClient();
  const { session } = useSession();

  const authorityLevel = useAuthorityLevel();
  const userId = session?.user?.id;

  const getCurrentModule = async () => {
    setLoading(true);
    const { data, error } = await client.fetch(`/learning_systems/${moduleId}?detailed=true`);
    if (error) {
      toast.error('Falha ao carregar módulo');
    } else {
      setCurrentModule(data);
    }
    setLoading(false);
    console.log(currentModule);
  };

  useEffect(() => {
    getCurrentModule();
  }, []);

  const downloadCertificate = async () => {
    window.open(`${process.env.REACT_APP_DEV_URL}//user_certificates/download/${currentModule?.['user-certificate-hash-id']}.pdf`, '_blank');
  };

  const isModuleEnabled = currentModule?.['learning-system-requirements']?.every(item => item.finished);
  return loading ? (
    <Loader />
  ) : (
    <div className="course-about__module">
      <div
        className="show-course-banner mb-6"
        style={{
          backgroundImage: `url(${currentModule?.image?.url || CourseCover})`,
          minHeight: '132px'
        }}
      >
        <div className="show-course-banner__inner">
          <div className="show-course-banner__container">
            {authorityLevel === 'student' && !currentModule?.['learning-system-users']?.find(item => item?.['user-id'] === parseInt(userId)) && <span className="badge badge--tiny badge--warning">{t('lms.tagNew')}</span>}
            {currentModule?.progress === 100 && <span className="badge badge--tiny badge--success">Concluído</span>}
            <div className="show-course-banner__title">{currentModule?.title}</div>
            {authorityLevel === 'student' && (
              <div className="card__progress card__progress--cover mb-0">
                <div className="card__progress-container">
                  <div
                    className="card__progress-bar"
                    style={{ width: `${currentModule?.progress ? parseInt(currentModule?.progress) : 0}%` }}
                  />
                </div>
                <div className="card__progress-text">{currentModule?.progress ? parseInt(currentModule?.progress) : 0}%</div>
              </div>
            )}
            {authorityLevel === 'student' && isModuleEnabled ? (
              <div className="show-course-banner__cta">
                <Link
                  className="btn btn--wide btn--outline"
                  to={`/show-course/${currentModule?.id}/classroom`}
                >
                  {currentModule.progress === 100 ? 'Visualizar conteúdo' : currentModule?.['learning-system-users']?.find(item => item?.['user-id'] === parseInt(userId)) ? t('lms.buttonContinue') : t('lms.buttonStartModule')}
                </Link>
                {currentModule?.['user-certificate-hash-id'] ? (
                  <button
                    className="btn btn--wide btn--outline-secondary"
                    onClick={() => {
                      downloadCertificate();
                    }}
                  >
                    {t('button.certification')}
                  </button>
                ) : null}
              </div>
            ) : null}
          </div>

          {currentModule?.progress === 100 && (
            <MedalContainer
              src="more"
              value={<TfiMedall />}
            />
          )}
        </div>
      </div>

      <div className="mb-6">
        <TabNavBar
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          questionbooksCount={currentModule?.['learning-system-question-books']?.length}
        />
      </div>

      {selectedTab === 'aulas' && <TabLessons currentModule={currentModule} />}
      {selectedTab === 'arquivos' && <TabFiles currentModule={currentModule} />}
      {selectedTab === 'atividades' && <TabActivities currentModule={currentModule} />}
      {selectedTab === 'apostilas' && <TabBooklet currentModule={currentModule} />}
    </div>
  );
}
